import {
  Box,
  Grid,
  IconButton,
  InputAdornment,
  Typography,
} from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import {
  AppNoTableData,
  FormTextField,
  GridCardContent,
} from "components/atoms";
import { FormContainer, FormContent } from "components/molecules";
import { FormikHelpers, useFormik } from "formik";
import {
  AlertHelper,
  ColorHelper,
  DialogHelper,
  StringHelper,
  TableHelper,
} from "helpers";
import _ from "lodash";
import {
  EInProcessCheckStatus,
  EInprocessCheckType,
  EQualityCheckingConditionType,
  IApiResponse,
  IDownloadInprocessCheck,
  IGetProductPacking,
  IGetProductPackingResponse,
  IInProcessCheckDetail,
  IProduct,
  IQualityCondition,
  IReviewInProcessRequest,
} from "model";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { theme } from "themes";
import { I18nTranslator, translations } from "utils/i18n";
import * as yup from "yup";
import AddIcon from "@mui/icons-material/Add";
import { IInProcessCheck } from "model";
import { PerformDetailModal } from "./PerformDetailModal";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { LoadingButton } from "@mui/lab";
import AssignmentIcon from "@mui/icons-material/Assignment";
import PreviewIcon from "@mui/icons-material/Preview";
import { ProductCodeSelect } from "./ProductCodeSelect";
import {
  InProcessCheckApiService,
  InProcessCheckDetailApiService,
  ProductApiService,
  QualityConditionApiService,
} from "services";
import { ECommonDialogType } from "components/molecules/CommonDialog";
import BasePage from "pages/base";
import { EAlertType } from "helpers/alertHelper";
import "themes/hide-increment-number-input.css";
import "./index.css";
import { Colors } from "utils";
import {
  canEditAfterReview,
  canPerformAndReview,
  canViewAndDownload,
  deletePhoto,
  getQualityConditionValue,
  getUnitPositionName,
} from "./helper";
import { ProductLotSelect } from "./ProductLotSelect";
import { DownloadActions } from "redux/actions";
import {
  useAppDispatch,
  useAppSelector,
} from "redux/configurations/reduxHooks";
import { Download } from "@mui/icons-material";
import Close from "@mui/icons-material/Close";
import Add from "@mui/icons-material/Add";

export const InProcessCheckDetail = () => {
  const dispatch = useAppDispatch();
  const downloading = useAppSelector(
    (state) => state.AppConfigReducer.downloading
  );

  const [selectedProcessDetail, setSelectedProcessDetail] =
    useState<IInProcessCheckDetail>();
  const [isOpenProcessDetailModal, setIsOpenProcessDetailModal] =
    useState<boolean>(false);
  const location = useLocation();
  const isAdd = location.pathname.includes("new");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isGetInProcessByIdLoading, setIsGetInProcessByIdLoading] =
    useState<boolean>(false);
  const [isLocalProductLot, setIsLocalProductLot] = useState<boolean>();
  const params = useParams<{ id: string }>();
  const history = useHistory();

  const formik = useFormik<TInProcessCheck>({
    initialValues: {
      inProcessCheckDetails: [],
      productId: "",
      productCode: "",
      productLot: "",
      totalQuantity: undefined,
    },
    enableReinitialize: true,
    validationSchema: ProcessReportValidateSchema,
    onSubmit: (values: TInProcessCheck, __: FormikHelpers<TInProcessCheck>) => {
      if (
        formik.values.status !== undefined &&
        formik.values.status !== EInProcessCheckStatus.New
      ) {
        history.length > 1 ? history.go(-1) : history.replace("/");
      } else {
        if (isAdd) {
          createInProcessCheckForm(values);
        } else {
          updateInProcessCheckForm(values);
        }
      }
    },
  });

  const shouldDisableGeneralInput = useMemo(
    () =>
      canPerformAndReview()
        ? (!isAdd && formik.values.status !== EInProcessCheckStatus.New) ||
          (formik.values.inProcessCheckDetails?.length ? true : false)
        : true,
    [formik.values.status, formik.values.inProcessCheckDetails, isAdd]
  );

  const shouldDisableReview = useMemo(
    () =>
      canEditAfterReview()
        ? false
        : canPerformAndReview()
        ? formik.values.status === EInProcessCheckStatus.Reviewed
          ? true
          : _.last(formik.values.inProcessCheckDetails)
          ? formik.values.type
            ? formik.values.inProcessCheckDetails
              ? false
              : true
            : // : _.last(formik.values.inProcessCheckDetails)!.numberOfUnitTo! <
              //   (formik.values.totalQuantity || 0)
              // ? true
              // : false
              false
          : true
        : true,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      formik.values.inProcessCheckDetails,
      formik.values.totalQuantity,
      formik.values.status,
    ]
  );

  const shouldDisableActionButton = useMemo(
    () =>
      canEditAfterReview()
        ? false
        : canPerformAndReview()
        ? formik.values.status === EInProcessCheckStatus.Reviewed
        : true,
    [formik.values.status]
  );

  const shouldDisableAddPerformanceButton = useMemo(
    () =>
      canEditAfterReview()
        ? false
        : canPerformAndReview()
        ? formik.values.status === EInProcessCheckStatus.Reviewed ||
          (formik.values.type === EInprocessCheckType.UNIT
            ? formik.values.inProcessCheckDetails?.length === 3
            : // : (_.last(formik.values.inProcessCheckDetails)?.numberOfUnitTo || 0) >=
              //   (formik.values.totalQuantity || 0)),
              false)
        : true,
    [
      formik.values.status,
      formik.values.type,
      formik.values.inProcessCheckDetails,
      // formik.values.totalQuantity,
    ]
  );

  const COLUMNS = useMemo<GridColDef<any, IInProcessCheckDetail>[]>(() => {
    return [
      {
        ...TableHelper.renderSTT(),
        sortable: false,
        disableColumnMenu: true,
        cellClassName: ({ row }) => (row.isLate ? "cell_yellow" : ""),
      } as GridColDef<any, IInProcessCheckDetail>,
      TableHelper.createCell<IInProcessCheckDetail>({
        field: "action",
        size: 128,
        headerName: I18nTranslator(translations.report.action),
        cellClassName: ({ row }) => (row.isLate ? "cell_yellow" : ""),
        renderCell: ({ row }) => (
          <div>
            <IconButton
              disabled={!canViewAndDownload()}
              onClick={() => {
                setSelectedProcessDetail(row);
                setIsOpenProcessDetailModal(true);
              }}
            >
              {shouldDisableActionButton ? (
                <PreviewIcon fontSize="small" color="primary" />
              ) : (
                <EditIcon fontSize="small" color="primary" />
              )}
            </IconButton>
            {!shouldDisableActionButton && (
              <IconButton
                disabled={!canPerformAndReview()}
                onClick={() =>
                  onDeletePerformClick(
                    row.id!,
                    row.qualityCheckingConditions
                      .map((e) => e.imageUrl)
                      .filter((e) => e) as string[]
                  )
                }
              >
                <DeleteIcon
                  sx={{ color: theme.colors.error.light }}
                  fontSize="small"
                />
              </IconButton>
            )}
          </div>
        ),
        sortable: false,
        disableColumnMenu: true,
      }),
      TableHelper.createCell<IInProcessCheckDetail>({
        field: "performedDate",
        headerName: I18nTranslator(
          translations.inProcessCheckReportDetail.date
        ),
        renderCell: ({ row }) =>
          `${moment.utc(row.performedTime).local().format("L")}`,
        sortable: false,
        disableColumnMenu: true,
        size: 120,
        cellClassName: ({ row }) => (row.isLate ? "cell_yellow" : ""),
      }),
      TableHelper.createCell<IInProcessCheckDetail>({
        field: "performedTime",
        headerName: I18nTranslator(
          translations.inProcessCheckReportDetail.time
        ),
        renderCell: ({ row }) => (
          <>
            {moment.utc(row.performedTime).local().format("HH:mm")}
            {row.isLate && (
              <Typography
                color={Colors.ERROR}
                fontWeight="bold"
                marginLeft={0.5}
              >
                ({I18nTranslator(translations.inProcessCheckReportDetail.late)})
              </Typography>
            )}
          </>
        ),
        sortable: false,
        disableColumnMenu: true,
        size: 120,
        cellClassName: ({ row }) => (row.isLate ? "cell_yellow" : ""),
      }),
      ...(formik.values.type === EInprocessCheckType.UNIT
        ? [
            TableHelper.createCell<IInProcessCheckDetail>({
              field: "unitPosition",
              headerName: I18nTranslator(
                translations.inProcessCheckReportDetail.unitPosition
              ),
              sortable: false,
              disableColumnMenu: true,
              renderCell: ({ row }) =>
                I18nTranslator(getUnitPositionName(row.unitPosition!)),
              cellClassName: ({ row }) => (row.isLate ? "cell_yellow" : ""),
            }),
          ]
        : []),
      ...(formik.values.qualityCheckingConditionMetadata?.map(
        (value, index) => {
          return TableHelper.createCell<IInProcessCheckDetail>({
            field: `quality_${index}`,
            // headerName: value.name,
            headerClassName: "table-header-custom",
            renderHeader: () => (
              <Typography fontWeight="500" whiteSpace={"pre-line"}>
                {value.name}
                <Typography color={"grey"} whiteSpace={"pre-line"}>
                  {value.nameEN}
                </Typography>
              </Typography>
            ),
            renderCell: ({ row }) => {
              if (value.type === EQualityCheckingConditionType.Predefined) {
                return I18nTranslator(
                  getQualityConditionValue(
                    row.qualityCheckingConditions[index].value
                  )
                );
              } else {
                return row.qualityCheckingConditions[index].value;
              }
            },
            sortable: false,
            disableColumnMenu: true,
            size: "full",
            cellClassName: ({ row }) => (row.isLate ? "cell_yellow" : ""),
          });
        }
      ) || []),
      ...(formik.values.type === EInprocessCheckType.UNIT
        ? [
            TableHelper.createCell<IInProcessCheckDetail>({
              field: "numberOfUnitFrom",
              headerName: I18nTranslator(
                translations.inProcessCheckReportDetail.unit
              ),
              sortable: false,
              disableColumnMenu: true,
              align: "right",
              size: "small",
              cellClassName: ({ row }) => (row.isLate ? "cell_yellow" : ""),
            }),
          ]
        : [
            TableHelper.createCell<IInProcessCheckDetail>({
              field: "numberOfUnitFrom",
              headerName: I18nTranslator(
                translations.inProcessCheckReportDetail.fromUnit
              ),
              sortable: false,
              disableColumnMenu: true,
              align: "right",
              size: "small",
              cellClassName: ({ row }) => (row.isLate ? "cell_yellow" : ""),
            }),
            TableHelper.createCell<IInProcessCheckDetail>({
              field: "numberOfUnitTo",
              headerName: I18nTranslator(
                translations.inProcessCheckReportDetail.toUnit
              ),
              sortable: false,
              disableColumnMenu: true,
              align: "right",
              size: "small",
              cellClassName: ({ row }) => (row.isLate ? "cell_yellow" : ""),
            }),
          ]),
      TableHelper.createCell<IInProcessCheckDetail>({
        field: "performedBy",
        headerName: I18nTranslator(
          translations.inProcessCheckReportDetail.performedBy
        ),
        sortable: false,
        disableColumnMenu: true,
        cellClassName: ({ row }) => (row.isLate ? "cell_yellow" : ""),
      }),
    ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    formik.values.qualityCheckingConditionMetadata,
    formik.values.inProcessCheckDetails,
    shouldDisableActionButton,
  ]);

  useEffect(() => {
    if (!isAdd && params.id) {
      getInProcessById(params.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getCardTitle = () => {
    return isAdd
      ? translations.inProcessCheckReportDetail.addReport
      : translations.inProcessCheckReportDetail.updateReport;
  };

  const onSaveProcessDetailSuccess = (value: IInProcessCheckDetail) => {
    if (!selectedProcessDetail) {
      formik.setFieldValue(
        "inProcessCheckDetails",
        formik.values.inProcessCheckDetails?.concat(value) || [value]
      );
      if (formik.values.status === EInProcessCheckStatus.New) {
        formik.setFieldValue("status", EInProcessCheckStatus.InProcess);
      }
    } else {
      const index = formik.values.inProcessCheckDetails!.findIndex(
        (e) => e.id === value.id
      );
      formik.setFieldValue(`inProcessCheckDetails.${index}`, value);
    }
    setSelectedProcessDetail(undefined);
    setIsOpenProcessDetailModal(false);
  };

  const getQualityConditionByGroupId = async (groupId: string) => {
    try {
      // setIsLoading(true);
      const result = (await QualityConditionApiService.getAllQualityCondition({
        groupId: groupId,
      })) as IApiResponse<IQualityCondition[]>;
      if (result.succeeded) {
        formik.setFieldValue(
          "qualityCheckingConditionMetadata",
          _.sortBy(
            result.data?.map((e) => ({
              name: e.name,
              displayOrder: e.displayOrder,
              type: e.type,
              imageRequied: e.imageRequired,
              nameEN: e.nameEN,
            })),
            (e) => e.displayOrder
          )
        );
      } else {
        console.error("error", result);
      }
    } catch (error) {
      console.error("error", error);
    } finally {
      // setIsLoading(false);
    }
  };

  const onProductSelected = (product: Partial<IProduct> | null) => {
    if (product) {
      getProductSpecification({ productId: product.id! });
      formik.setValues({
        ...formik.values,
        // numberOfUnit: product.quantityByUnit,
        productCode: product.productCode!,
        groupId: product.groupId,
        type: product.group?.checkType,
        productId: product.id!,
        groupDescription: product.group?.description,
        uom: product.uom,
        productLot: "",
      });
      setIsLocalProductLot(product.group?.isLocal);
    } else {
      formik.setValues({
        ...formik.values,
        numberOfUnit: undefined,
        inProcessCheckDetails: undefined,
        qualityCheckingConditionMetadata: undefined,
        productCode: "",
        productId: "",
        productLot: "",
      });
      setIsLocalProductLot(undefined);
    }
  };

  const onDeletePerformClick = (id: string, imageUrls: string[]) => {
    DialogHelper.open({
      title: I18nTranslator(translations.dialog.warning),
      message: I18nTranslator(
        translations.inProcessCheckReportDetail.deletePerformConfirm
      ),
      type: ECommonDialogType.WARNING,
      onConfirm: () => deleteInProcessPerform(id, imageUrls),
      isCancel: true,
    });
  };

  const onReviewInProcessClick = () => {
    if (
      formik.values.type! === EInprocessCheckType.TIME &&
      formik.values.totalQuantity! >
        _.last(formik.values.inProcessCheckDetails)!.numberOfUnitTo!
    ) {
      DialogHelper.open({
        title: I18nTranslator(
          translations.inProcessCheckReportDetail.unitToLessThanTotal
        ),
        message: I18nTranslator(
          translations.inProcessCheckReportDetail.doYouWantToContinue
        ),
        isCancel: true,
        onConfirm: () => {
          DialogHelper.open({
            title: I18nTranslator(translations.dialog.warning),
            message: I18nTranslator(
              translations.inProcessCheckReportDetail
                .reviewInProcessCheckConfirm
            ),
            type: ECommonDialogType.WARNING,
            onConfirm: () =>
              reviewInProcessCheck(formik.values.id!, {
                reviewedNote: formik.values.reviewedNote,
              }),
            isCancel: true,
          });
        },
        type: ECommonDialogType.WARNING,
      });
    } else {
      DialogHelper.open({
        title: I18nTranslator(translations.dialog.warning),
        message: I18nTranslator(
          translations.inProcessCheckReportDetail.reviewInProcessCheckConfirm
        ),
        type: ECommonDialogType.WARNING,
        onConfirm: () =>
          reviewInProcessCheck(formik.values.id!, {
            reviewedNote: formik.values.reviewedNote,
          }),
        isCancel: true,
      });
    }
  };

  const downloadInprocessCheck = () => {
    const params: IDownloadInprocessCheck = {
      id: formik.values.id!,
      fileName: `Inprocess check_${formik.values.productCode}_${
        formik.values.productName
      }_reviewed on_${moment
        .utc(formik.values.reviewedTime)
        .format("DD/MM/YYYY_HH:mm")}`,
    };
    dispatch(DownloadActions.downloadInprocessCheck.request(params));
  };

  const getInProcessById = async (id: string) => {
    try {
      setIsGetInProcessByIdLoading(true);
      const result = (await InProcessCheckApiService.getInProcessCheckById(
        id
      )) as IApiResponse<IInProcessCheck>;
      if (result.succeeded) {
        const detailResult = await getAllInProcessPerform(result.data!.id!);
        if (detailResult?.succeeded) {
          formik.setValues({
            ...result.data!,
            inProcessCheckDetails: detailResult.data!,
          });
        }
      } else {
        DialogHelper.open({
          title: I18nTranslator(translations.dialog.warning),
          message: I18nTranslator(
            translations.inProcessCheckReportDetail.ProcessCheckNotFound
          ),
          type: ECommonDialogType.WARNING,
          onConfirm: () => history.push("/report/inProcess-check"),
        });
      }
    } catch (error) {
      console.error("error", error);
    } finally {
      setIsGetInProcessByIdLoading(false);
    }
  };

  const getAllInProcessPerform = async (inProcesscheckId: string) => {
    try {
      const result =
        (await InProcessCheckDetailApiService.getAllInProcessCheckDetail({
          inProcessCheckId: inProcesscheckId,
          pageNumber: 1,
          pageSize: 9999,
        })) as IApiResponse<IInProcessCheckDetail[]>;
      return result;
    } catch (error) {
      console.error("error", error);
    }
  };

  const createInProcessCheckForm = async (request: IInProcessCheck) => {
    try {
      setIsLoading(true);
      const result = (await InProcessCheckApiService.createInProcessCheck(
        request
      )) as IApiResponse<IInProcessCheck>;
      if (result.succeeded) {
        formik.setValues(result.data!);
        getQualityConditionByGroupId(formik.values.groupId!);
        history.replace(result.data!.id!);
      } else {
        AlertHelper.showError(result);
      }
    } catch (error) {
      console.error("error", error);
    } finally {
      setIsLoading(false);
    }
  };

  const updateInProcessCheckForm = async (request: IInProcessCheck) => {
    try {
      setIsLoading(true);
      const result = (await InProcessCheckApiService.updateInProcessCheck(
        request
      )) as IApiResponse<IInProcessCheck>;
      if (result.succeeded) {
        const { inProcessCheckDetails, ...updatedInProcessCheck } =
          result.data!;
        formik.setValues({ ...formik.values, ...updatedInProcessCheck });
        if (
          formik.values.status === EInProcessCheckStatus.New ||
          (!formik.values.inProcessCheckDetails?.length ? true : false)
        ) {
          const product = (await ProductApiService.getProductById({
            id: result.data!.productId!,
          })) as IApiResponse<IProduct>;
          if (product.succeeded && product.data) {
            getQualityConditionByGroupId(product.data.groupId!);
          }
        }
        AlertHelper.showAlert(
          I18nTranslator(
            translations.inProcessCheckReportDetail.inProcessCheckUpdatedSuccess
          ),
          EAlertType.SUCCESS
        );
      } else {
        AlertHelper.showError(result);
      }
    } catch (error) {
      console.error("error", error);
    } finally {
      setIsLoading(false);
    }
  };

  const reviewInProcessCheck = async (
    id: string,
    request: IReviewInProcessRequest
  ) => {
    try {
      setIsGetInProcessByIdLoading(true);
      const result = (await InProcessCheckApiService.reviewInProcessCheck(
        id,
        request
      )) as IApiResponse<any>;
      if (result.succeeded) {
        formik.setFieldValue("status", EInProcessCheckStatus.Reviewed);
        AlertHelper.showAlert(
          I18nTranslator(
            translations.inProcessCheckReportDetail.reviewInProcessCheckSuccess
          ),
          EAlertType.SUCCESS
        );
      } else {
        AlertHelper.showError(result);
      }
    } catch (error) {
      console.error("error", error);
    } finally {
      setIsGetInProcessByIdLoading(false);
    }
  };

  const deleteInProcessPerform = async (id: string, imageUrls: string[]) => {
    try {
      setIsLoading(true);
      const result =
        (await InProcessCheckDetailApiService.deleteInProcessCheckDetail(
          id
        )) as IApiResponse<string>;
      imageUrls.length &&
        Promise.all(imageUrls.map((e) => deletePhoto(e))).then((res) => {
          if (res.some((e) => !e)) {
            AlertHelper.showAlert(
              I18nTranslator(
                translations.inProcessCheckReportDetail.deleteImageError
              ),
              EAlertType.WARNING
            );
          }
        });
      if (result.succeeded) {
        AlertHelper.showAlert(
          I18nTranslator(
            translations.inProcessCheckReportDetail.performDeletedSuccess
          ),
          EAlertType.SUCCESS
        );
        formik.setFieldValue(
          "inProcessCheckDetails",
          formik.values.inProcessCheckDetails!.filter((e) => e.id !== id)
        );
      } else {
        AlertHelper.showError(result);
      }
    } catch (error) {
      console.error("Network error", error);
    } finally {
      setIsLoading(false);
    }
  };

  const getProductSpecification = async (request: IGetProductPacking) => {
    try {
      const result = (await ProductApiService.getProductPacking(
        request
      )) as IGetProductPackingResponse;
      if (result.succeeded && result.data) {
        const level1Carton = result.data.find((e) => e.level === 1);
        if (level1Carton) {
          formik.setFieldValue("numberOfUnit", level1Carton.quantity);
        } else {
          formik.setFieldValue("numberOfUnit", result.data[0]?.quantity);
        }
      } else {
        AlertHelper.showError(result);
      }
    } catch (error) {}
  };

  return (
    <BasePage loading={isGetInProcessByIdLoading}>
      <GridCardContent>
        <Box sx={{ bgcolor: "white", p: 2, height: "100%", width: "100%" }}>
          <FormContainer
            formik={formik}
            loading={isLoading}
            isAdd={isAdd}
            // onDelete={handleDeleteItem}
            title={I18nTranslator(getCardTitle())}
            renderButtons={
              formik.values.id && (
                <>
                  {formik.values.status === EInProcessCheckStatus.Reviewed && (
                    <LoadingButton
                      variant="contained"
                      color="primary"
                      loading={downloading}
                      startIcon={<Download />}
                      onClick={() => downloadInprocessCheck()}
                      disabled={!canViewAndDownload()}
                      style={{ marginRight: "16px" }}
                    >
                      {I18nTranslator(translations.export)}
                    </LoadingButton>
                  )}
                  <LoadingButton
                    variant="contained"
                    color="primary"
                    loading={isLoading}
                    startIcon={<AssignmentIcon />}
                    disabled={
                      isLoading ||
                      (canEditAfterReview() ? false : shouldDisableReview)
                    }
                    onClick={() => onReviewInProcessClick()}
                  >
                    {I18nTranslator(
                      translations.inProcessCheckReportDetail.review
                    )}
                  </LoadingButton>
                </>
              )
            }
            renderConfirmButton={
              <LoadingButton
                variant="contained"
                type="submit"
                color="primary"
                loading={isLoading}
                startIcon={<Add />}
                disabled={!canPerformAndReview()}
              >
                {I18nTranslator(
                  translations.inProcessCheckReportDetail.createForm
                )}
              </LoadingButton>
            }
            saveButtonTitle={
              formik.values.status !== EInProcessCheckStatus.New
                ? I18nTranslator(translations.button.close)
                : undefined
            }
            saveButtonIcon={
              formik.values.status !== EInProcessCheckStatus.New ? (
                <Close />
              ) : undefined
            }
            disableSubmit={false}
          >
            {!isGetInProcessByIdLoading && formik.values && (
              <>
                <Typography
                  style={{
                    backgroundColor: ColorHelper.getInProcessStatusColor(
                      formik.values.status!
                    ),
                    padding: "3px 16px",
                    borderRadius: "3px",
                    color: "white",
                    fontWeight: "bold",
                    width: "fit-content",
                    marginBottom: "16px",
                  }}
                >
                  {StringHelper.getInProcessStatusName(formik.values.status!)}
                </Typography>
                <FormContent
                  title={I18nTranslator(
                    translations.inProcessCheckReportDetail.generalInfo
                  )}
                >
                  <Grid xs={6} item>
                    <ProductCodeSelect
                      onProductSelected={onProductSelected}
                      defaultValue={{ productCode: formik.values.productCode }}
                      disabled={shouldDisableGeneralInput}
                      additionalLabel={
                        !isAdd ? formik.values.productName : undefined
                      }
                    />
                  </Grid>
                  <Grid xs={6} item>
                    <ProductLotSelect
                      disabled={shouldDisableGeneralInput}
                      defaultValue={formik.values.productLot}
                      productId={formik.values.productId}
                      isLocal={isLocalProductLot}
                    />
                  </Grid>
                  <Grid xs={6} item>
                    <FormTextField
                      label={I18nTranslator(translations.report.packSize)}
                      placeholder={I18nTranslator(translations.report.packSize)}
                      id="numberOfUnit"
                      disabled
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            {formik.values.uom}
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid xs={6} item>
                    <FormTextField
                      required
                      label={I18nTranslator(
                        translations.inProcessCheckReportDetail.totalQuantity
                      )}
                      placeholder={I18nTranslator(
                        translations.inProcessCheckReportDetail.totalQuantity
                      )}
                      id="totalQuantity"
                      disabled={shouldDisableGeneralInput}
                      type="number"
                    />
                  </Grid>
                </FormContent>
                {formik.values.id && (
                  <FormContent
                    title={I18nTranslator(
                      translations.inProcessCheckReportDetail.performances
                    )}
                  >
                    {formik.values.groupDescription && (
                      <Grid item>
                        <Typography fontWeight="bold" color="grey">
                          {formik.values.groupDescription}
                        </Typography>
                      </Grid>
                    )}
                    {!_.isEmpty(
                      formik.values.qualityCheckingConditionMetadata
                    ) && (
                      <Grid
                        item
                        xs={12}
                        style={{
                          height: 480,
                          marginTop: "10px",
                          width: "100%",
                        }}
                      >
                        <DataGrid
                          loading={isGetInProcessByIdLoading}
                          rows={
                            formik.values.inProcessCheckDetails?.map(
                              (e, index) => {
                                return {
                                  no: index + 1,
                                  ...e,
                                };
                              }
                            ) || []
                          }
                          columns={COLUMNS}
                          components={{
                            Footer: () => (
                              <LoadingButton
                                color="primary"
                                variant="contained"
                                sx={{
                                  marginTop: 2,
                                }}
                                onClick={() => {
                                  if (
                                    !formik.values.inProcessCheckDetails?.length
                                  ) {
                                    setIsOpenProcessDetailModal(true);
                                  } else if (
                                    formik.values.type! ===
                                      EInprocessCheckType.TIME &&
                                    formik.values.totalQuantity! <=
                                      _.last(
                                        formik.values.inProcessCheckDetails
                                      )!.numberOfUnitTo!
                                  ) {
                                    DialogHelper.open({
                                      title: I18nTranslator(
                                        translations.inProcessCheckReportDetail
                                          .unitToEqualTotal
                                      ),
                                      message: I18nTranslator(
                                        translations.inProcessCheckReportDetail
                                          .doYouWantToContinue
                                      ),
                                      isCancel: true,
                                      onConfirm: () =>
                                        setIsOpenProcessDetailModal(true),
                                      type: ECommonDialogType.WARNING,
                                    });
                                  } else {
                                    setIsOpenProcessDetailModal(true);
                                  }
                                }}
                                disabled={shouldDisableAddPerformanceButton}
                                startIcon={<AddIcon fontSize={"small"} />}
                              >
                                {I18nTranslator(
                                  translations.inProcessCheckReportDetail
                                    .addPerformance
                                )}
                              </LoadingButton>
                            ),
                            NoRowsOverlay: () => <AppNoTableData />,
                          }}
                          hideFooterPagination
                          hideFooterSelectedRowCount
                          // onCellEditCommit={handleEditCell}
                          headerHeight={100}
                        />
                      </Grid>
                    )}
                    {formik.values.id && (
                      <Grid xs={12} item>
                        <FormTextField
                          label={I18nTranslator(
                            translations.inProcessCheckReportDetail.reviewedNote
                          )}
                          placeholder={I18nTranslator(
                            translations.inProcessCheckReportDetail.reviewedNote
                          )}
                          id="reviewedNote"
                          multiline
                          rows={4}
                          disabled={isLoading || shouldDisableReview}
                        />
                      </Grid>
                    )}
                  </FormContent>
                )}
                {formik.values.id && formik.values.inProcessCheckDetails ? (
                  <PerformDetailModal
                    open={isOpenProcessDetailModal}
                    processDetail={selectedProcessDetail}
                    inProcessId={formik.values.id}
                    onSuccess={(value) => {
                      onSaveProcessDetailSuccess(value);
                    }}
                    handleClose={() => {
                      setSelectedProcessDetail(undefined);
                      setIsOpenProcessDetailModal(false);
                    }}
                    lastProcessDetail={_.last(
                      formik.values.inProcessCheckDetails
                    )}
                  />
                ) : null}
              </>
            )}
          </FormContainer>
        </Box>
      </GridCardContent>
    </BasePage>
  );
};

const ProcessReportValidateSchema = yup.object().shape({
  productCode: yup.string().required(translations.yupError.required),
  productId: yup.string().required(translations.yupError.required),
  productLot: yup.string().required(translations.yupError.required),
  totalQuantity: yup
    .number()
    .typeError(translations.yupError.formatNotValid)
    .integer(translations.yupError.formatNotValid)
    .required(translations.yupError.required),
});

type TInProcessCheck = IInProcessCheck & {
  groupId?: string;
};
